import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/SiteGeral";

/**
 * Classe de gerenciamento de chamadas da API do ProcedimentoPlanoOperadora
 *
 * @class
 */

export default class SiteGeralApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  constructor(api: $Fetch) {
    this.api = api;
  }

  ListarExames() {
    return this.api<any[]>(`${controller}/Exames/Lista`, {
      method: "GET",
    });
  }

  ListarEspecialidades() {
    return this.api<any[]>(`${controller}/Especialidades/Lista`, {
      method: "GET",
    });
  }

  ListarMedicos() {
    return this.api<any[]>(`${controller}/Medicos/Lista`, {
      method: "GET",
    });
  }

  ListarConvenios() {
    return this.api<any[]>(`${controller}/Convenios/Lista`, {
      method: "GET",
    });
  }
}
